import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private snackBar = inject(MatSnackBar);

  showSuccess(message: string, duration = 1500): void {
    this.show(message, 'success', duration);
  }

  showError(error: string | HttpErrorResponse | unknown, duration = 5000) {
    const errorMessage = this.getErrorMessage(error);

    // Makes errors visible in android studio console
    console.error(typeof error === 'string' ? error : JSON.stringify(error));
    this.show(errorMessage, 'danger', duration);
  }

  show(message: string, color: 'primary' | 'success' | 'danger' = 'primary', duration = 3000) {
    this.snackBar.open(message, undefined, {
      duration,
      verticalPosition: 'top',
      panelClass: color,
    });
  }

  private getErrorMessage(error: string | HttpErrorResponse | unknown): string {
    if (typeof error === 'string') {
      return error;
    }

    // TODO: remove this line and uncomment the other lines after adding translations
    return 'An unexpected error occurred.';

    // if (error instanceof HttpErrorResponse) {
    //   return this.getHttpErrorMessage(error);
    // }

    // return this.translateService.instant('errors.generic');
  }

  // private getHttpErrorMessage(error: HttpErrorResponse): string {
  //   switch (error.status) {
  //     case 0:
  //       return this.translateService.instant('errors.network');
  //     case 404:
  //       return this.translateService.instant('errors.not_found');
  //     case 500:
  //       return this.translateService.instant('errors.generic');
  //     default:
  //       return this.translateService.instant('errors.generic');
  //   }
  // }
}
